<script>
  import { fade } from "svelte/transition";

  function overlay_click(e) {
    // if ("close" in e.target.dataset) show = false;
  }
  export let show = false;
</script>

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .modal-container {
    position: relative;
    background-color: #fff;
    padding: 0;
    width: 100%;
    height: calc(100vh);
    margin: auto;
  }
</style>

{#if show}
    <div class="modal-overlay" data-close on:click={overlay_click} transition:fade={{ duration: 150 }}>
      <div class="modal-container">
        <slot />
      </div>
    </div>
{/if}
